import { Component, inject } from '@angular/core'
import { RouterLink } from '@angular/router'
import { AppDownloadService } from '@ftr/api-core'
import { isInDesktopApp } from '@ftr/foundation'

@Component({
  selector: 'ftr-footer-help-links',
  templateUrl: './footer-help-links.component.html',
  styleUrls: ['./footer-help-links.component.css'],
  imports: [RouterLink],
})
export class FooterHelpLinksComponent {
  private readonly appDownloadService = inject(AppDownloadService)

  getDesktopUrl: string
  showDesktopDownloadLink = !isInDesktopApp()

  constructor() {
    this.getDesktopUrl = this.appDownloadService.getStandaloneAppLink()
  }
}
